import { OrdersModel } from '@pukka/api';
import { numberUtils, stringUtils } from '@pukka/common/utils';
import { Text } from '@pukka/ui-components';

interface ReceiptDiscountTableProps {
  readonly discounts?: OrdersModel.OrderDiscount[];
}

export default function ReceiptDiscountTable({ discounts }: ReceiptDiscountTableProps) {
  return (
    <div>
      {discounts?.map((paymentDiscount, i) => (
        <div className="flex justify-between py-1" key={i}>
          <Text variant="body-1" className="text-left">
            {stringUtils.limitTo(paymentDiscount.discount_name, 20)}
            {paymentDiscount.discount_name.length > 20 ? '...' : ' '}
            (Rp)
          </Text>

          <Text variant="body-1" className="w-36 text-right">
            ({numberUtils.formatCurrency(Math.abs(paymentDiscount.discount_amount), 'Rp.')})
          </Text>
        </div>
      ))}
    </div>
  );
}
